import React from 'react';
import PropTypes from 'prop-types';
import {
  PlainText,
  Modal,
  TechniqueCardDescription,
  Image,
} from '@learningblocks/exp-components';
import LightBulb from '@learningblocks/exp-constants/lib/Images/lighbulb.svg';
import MoveCard from '@learningblocks/exp-constants/lib/Images/move.svg';
import TrashCan from '@learningblocks/exp-constants/lib/Images/mini-trash-icon.svg';
import './style.scss';

export class FullWidthCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
    };
  }

  modalOpen = () => {
    this.setState({modalOpen: true});
  };

  modalClose = () => {
    this.setState({modalOpen: false});
  };

  modalWindow = () => {
    return (
      this.state.modalOpen && (
        <Modal
          isOpen={this.state.modalOpen}
          className='md'
          contentLabel={this.props.modal.title}
          closeButton={true}
          close={this.modalClose}>
          <TechniqueCardDescription {...this.props.modal} />
        </Modal>
      )
    );
  };

  modalButton = () => {
    return (
      <div className='card-icons__modal' onClick={this.modalOpen}>
        <Image src={LightBulb} alt='open-modal-window' />
      </div>
    );
  };

  addButton = () => {
    if (this.props.addCard !== null) {
      return (
        <div className='card-icons__add' onClick={this.props.addCard}>
          <Image src={MoveCard} alt='add-card-option' />
        </div>
      );
    } else {
      return null;
    }
  };

  removeButton = () => {
    if (this.props.removeCard !== null) {
      return (
        <div className='card-icons__remove' onClick={this.props.removeCard}>
          <Image src={TrashCan} alt='trash-card-option' />
        </div>
      );
    } else {
      return null;
    }
  };

  render() {
    return (
      <>
        <div className='card'>
          <div className='card-image'>
            <Image src={this.props.image} alt={this.props.title} />
          </div>
          <div className='card-content'>
            <PlainText text={this.props.title} />
            <PlainText text={this.props.description} />
          </div>
          <div className='card-icons'>
            {this.modalButton()}
            {this.addButton()}
            {this.removeButton()}
          </div>
        </div>
        {this.modalWindow()}
      </>
    );
  }
}
FullWidthCard.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  modal: PropTypes.object,
  removeCard: PropTypes.oneOfType([PropTypes.any, PropTypes.func]),
  addCard: PropTypes.oneOfType([PropTypes.any, PropTypes.func]),
};

FullWidthCard.defaultProps = {
  removeCard: null,
  addCard: null,
};
